import { Component, input, output } from '@angular/core';
import { DashboardListDto } from 'app/common/generated';
import { TranslocoModule } from '@jsverse/transloco';
import { NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-dashboard-card',
    standalone: true,
    imports: [TranslocoModule, NgClass, MatButtonModule, MatIconModule, MatTooltipModule],
    templateUrl: './dashboard-card.component.html',
    styleUrl: './dashboard-card.component.scss',
})
export class DashboardCardComponent {
    readonly dashboard = input.required<DashboardListDto>();
    readonly isPreferred = input<boolean>(false);
    readonly showActions = input<boolean>(true);
    readonly showPreferredButton = input<boolean>(true);
    readonly translationPrefix = input<string>('dashboard-list');
    readonly showThematic = input<boolean>(true);

    // @Output() doubleClick = new EventEmitter<DashboardListDto>();
    readonly view = output<DashboardListDto>();
    readonly editDesign = output<DashboardListDto>();
    readonly edit = output<DashboardListDto>();
    readonly delete = output<DashboardListDto>();
    readonly share = output<DashboardListDto>();
    readonly togglePreferred = output<DashboardListDto>();

    // onDoubleClick(): void {
    //     this.doubleClick.emit(this.dashboard);
    // }

    onView(): void {
        this.view.emit(this.dashboard());
    }

    onEditDesign(): void {
        this.editDesign.emit(this.dashboard());
    }

    onEdit(): void {
        this.edit.emit(this.dashboard());
    }

    onDelete(): void {
        this.delete.emit(this.dashboard());
    }

    onShare(): void {
        this.share.emit(this.dashboard());
    }

    onTogglePreferred(): void {
        this.togglePreferred.emit(this.dashboard());
    }

    get displayName(): string {
        return (
            this.dashboard().name || this.getTranslatedText('unnamed-dashboard')
        );
    }

    get displayDescription(): string {
        return (
            this.dashboard().description ||
            this.getTranslatedText('no-description')
        );
    }

    private getTranslatedText(key: string): string {
        return `${this.translationPrefix()}.${key}`;
    }
}
